import styled from "@emotion/styled";
import {Bindings} from "data/constants/bindings";
import {useViewController} from "data/services/locator";
import {observer} from "mobx-react";
import React from "react";
import {useLocation} from "react-router";
import {NavLink} from "react-router-dom";
import {ILocalizationController} from "views/controllers/localization/localization.controller";

const Wrapper = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;

	a {
		width: 100%;
		text-align: center;
		padding: 10px 12px;
		font-size: 14px;
		font-style: normal;
		font-weight: 600;
		line-height: 140%;
		text-transform: capitalize;
		color: #848990;
		border-bottom: 2px solid transparent;

		&.active {
			color: #ffffff;
			border-color: #28cdfb;
		}
	}
`;

export const GameNavigation: React.FC = observer(() => {
	const location = useLocation();
	const isLanding = location.pathname === "/";

	const {i18n} = useViewController<ILocalizationController>(Bindings.LocalizationController);

	if (isLanding) {
		return null;
	}

	return (
		<Wrapper>
			<NavLink to="/play">{i18n.t("game.navigation.roster", "My Roster")}</NavLink>
			<NavLink to="/leagues">{i18n.t("game.navigation.leagues", "League")}</NavLink>
			<NavLink to="/head_to_head/games">{i18n.t("game.navigation.h2h", "H2H")}</NavLink>
		</Wrapper>
	);
});
